<div class="accordion" id="accordionExample" style="margin-top: -25px;">

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse4"
                    aria-expanded="false" aria-controls="collapse4">
                Inhoudingsplichtige
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Vul de naam van de vennootschap in zoals deze bij de Belastingdienst bekend is.
                <div class="space20"></div>

                Alle bedrijven en organisaties krijgen bij inschrijving naast een KVK-nummer ook een Rechtspersonen en
                Samenwerkingsverbanden Informatienummer (RSIN). Daarop geldt één uitzondering: eenmanszaken krijgen geen
                RSIN. Het RSIN kun je, net als het KVK-nummer, gebruiken om gegevens uit te wisselen met
                (overheids)organisaties, zoals de Belastingdienst.

                <div class="space20"></div>

            </div>
        </div>
    </div>

</div>
